export const dimensions = {
  border: {
    default: '1.4px',
    none: '0px',
    x1: '1px',
    x2: '2px',
    x3: '3px',
    x4: '4px',
    x8: '8px',
  },
  radius: {
    buttons: '6px',
    containers: '8px',
    dialogs: '8px',
    drops: '8px',
    fields: '6px',
    tags: '9999px',
  },
  sizing: {
    global: {
      none: '0px',
      x1: '1px',
      x2: '2px',
      x4: '4px',
      x6: '6px',
      x8: '8px',
      x10: '10px',
      x12: '12px',
      x14: '14px',
      x16: '16px',
      x20: '20px',
      x24: '24px',
      x28: '28px',
      x32: '32px',
      x36: '36px',
      x40: '40px',
      x44: '44px',
      x48: '48px',
      x56: '56px',
      x64: '64px',
      x72: '72px',
      x80: '80px',
      x88: '88px',
      x96: '96px',
      x104: '104px',
      x112: '112px',
      x120: '120px',
      x128: '128px',
    },
    icon: {
      large: '24px',
      medium: '20px',
      small: '16px',
      xlarge: '28px',
      xsmall: '14px',
      xsmall2: '12px',
      xsmall3: '10px',
    },
    shape: {
      large: '56px',
      medium: '44px',
      small: '36px',
      xlarge: '64px',
      xsmall: '28px',
      xsmall2: '20px',
      xsmall3: '16px',
      xsmall4: '14px',
      xsmall5: '12px',
    },
  },
  spacing: {
    large: '20px',
    medium: '16px',
    small: '12px',
    xlarge: '24px',
    xlarge2: '28px',
    xlarge3: '32px',
    xlarge4: '36px',
    xsmall: '8px',
    xsmall2: '4px',
    xsmall3: '2px',
  },
  'z-index': {
    auto: 'auto',
    none: '0px',
    x10: '10px',
    x20: '20px',
    x30: '30px',
    x40: '40px',
    x50: '50px',
  },
} as const
